// The iPad's last few API failures, attached to every Feedback report
// (D-LAUNCH3). In memory only: a reload clears it, which is fine — the report
// is about what just happened. No request or response bodies, ever.

const MAX = 5;
const buffer = [];

export function recordApiError({ method, path, status, message }) {
  buffer.push({
    at: new Date().toISOString(),
    method: String(method || ''),
    // Query string dropped: a failed History search can carry a customer
    // address or other job details in it (e.g. GET /lookups?q=123+Main+St),
    // and this buffer rides along on every Feedback report.
    path: String(path || '').split('?')[0].slice(0, 200),
    status: Number.isInteger(status) ? status : null,
    message: String(message || '').slice(0, 200),
  });
  while (buffer.length > MAX) buffer.shift();
}

export function recentApiErrors() {
  return buffer.map((e) => ({ ...e }));
}

export function resetRecentErrors() {
  buffer.length = 0;
}
